import React, { createContext, useContext } from 'react';
import WebAppConfig from '../components/configuration/webapp-config';

const EventConfigContext = createContext();

export const EventConfigProvider = ({ children }) => { 
    const {config} = WebAppConfig(); 

    const eventConfig = {
        slug: config.REACT_APP_EVENT_SLUG,
        apiUrl: config.REACT_APP_API_URL,
        getApiUrl: (endpoint) => `${config.REACT_APP_API_URL}/${endpoint}`,
    };

    return (
        <EventConfigContext.Provider value={eventConfig}>
            {children}
        </EventConfigContext.Provider>
    );
};
 

export const useEventConfig = () => {
    const context = useContext(EventConfigContext);
    if (!context) {
        throw new Error('useEventConfig must be used within an EventConfigProvider');
    }
    return context;
};